/**
 * Default timeout in milliseconds for health check operations.
 * Each dependency check will timeout after this duration.
 */
export const CHECK_TIMEOUT_MS = 30000
